import axios from 'axios'
import store from '../store'
import router from '../router'
import common from '../api/common'

import qs from 'qs' //qs.parse()url参数转对象  qs.stringify()对象转url参数
import { Indicator, Toast, MessageBox } from 'mint-ui'
// if (process.env.NODE_ENV == 'development') {
//   axiosIns.defaults.baseURL = '***';
// } else if (process.env.NODE_ENV == 'debug') {
//   axiosIns.defaults.baseURL = '***';
// } else if (process.env.NODE_ENV == 'production') {
//   axiosIns.defaults.baseURL = '***';
// }

// 全局默认配置
// 设置 POST 请求头
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
// 配置 CORS 跨域
axios.defaults.withCredentials = true//本地起的node服务需要注释这个
axios.defaults.crossDomain = true
axios.defaults.timeout = 8000

// 请求发起前拦截器
axios.interceptors.request.use(
  config => {
    // 全局 loading 状态，触发 loading 效果

    store.commit('changeLoading', true)
    if (localStorage.getItem('token') != null) {
      config.headers = {
        id: localStorage.getItem('managerId'),
        token: localStorage.getItem('token')
      } //设置请求头，看业务需求
    }
    if (config.method == 'post') {
      // config.data = {
      //   ...config.data,
      //   t: Date.now(),//每个请求后加时间戳
      // }
      config.url = config.url + '?t=' + Date.now()
    } else if (config.method == 'get') {
      config.params = {
        t: Date.now(), //每个请求后加时间戳
        ...config.params
      }
    }

    // POST 请求参数处理成 axios post 方法所需的格式
    //   if (config.method === 'post') {
    //     // config.data = qs.stringify(config.data);
    //   }
    // 这句不能省，不然后面的请求就无法成功发起，因为读不到配置参数
    return config
  },
  () => {
    // 异常处理
    store.commit('changeLoading', false)
  }
)
// 响应拦截
axios.interceptors.response.use(
  response => {
    localStorage.setItem('code', response.data.code)

    // 关闭 loading 效果
    store.commit('changeLoading', false)
    // 全局登录过滤，如果没有登录，直接跳转到登录 URL
    if (response.data.code === 9999) {
      //token过期
      // 未登录
      localStorage.clear()
      router.push('/login')
      return false
    }

    // 这里返回的 response.data 是被 axios 包装过的一成，所以在这里抽取出来
    // console.log(response.data)
    return response.data
  },
  error => {
    store.commit('changeLoading', false)
    Toast(error.message)
    // Toast("网络繁忙，请稍后重试")
    return Promise.reject(error)
  }
)
// 导出
export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js